import CashAccountOffageDetailsBase from './base/CashAccountOffageDetailsBase';

/**
 * @class CashAccountOffageDetails
 * @extends CashAccountOffageDetailsBase
 */
class CashAccountOffageDetails extends CashAccountOffageDetailsBase {

}

export default CashAccountOffageDetails;
